import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * YouTube wordmark (play button + logotype) for authorised-data headers.
 */
export const YouTubeWordmark: FC<Props> = (props) => (
  <svg
    width="80"
    height="32"
    viewBox="0 0 621 139"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="YouTube"
    {...props}
  >
    <g clipPath="url(#youtubeWordmarkClip)">
      <path
        d="M21.6 133.93C13.1 131.63 6.48 124.86 4.03 116.5C0 101.1 0 68.98 0 68.98C0 68.98 0 36.87 4.03 21.6C6.48 13.11 13.1 6.48 21.6 4.18C36.87 0 98.5 0 98.5 0C98.5 0 160.28 0 175.55 4.18C184.19 6.48 190.67 13.11 192.98 21.61C197.16 36.88 197.16 68.99 197.16 68.99C197.16 68.99 197.16 101.1 192.98 116.51C190.68 124.86 184.19 131.63 175.55 133.94C160.28 138.12 98.5 138.12 98.5 138.12C98.5 138.12 36.86 138.12 21.6 133.94V133.93ZM78.92 98.65L130.04 68.98L78.92 39.46V98.65Z"
        fill="#FF0033"
      />
      <path d="M78.9199 98.65L130.04 68.98L78.9199 39.46V98.65Z" fill="white" />
      <path
        d="M239.11 129.61V91.8101L216.28 8.64014H236.08L244.29 45.5101C246.16 54.0101 248.11 66.1801 248.97 70.5701H249.11C249.97 66.3201 251.85 54.1501 253.79 45.6601L262.29 8.65014H282.09L258.98 91.8201V129.62H239.11V129.61Z"
        fill="#212121"
      />
      <path
        d="M330.41 81.8V88.86C330.41 120.25 323.5 130.91 302.9 130.91C282.3 130.91 275.39 119.97 275.39 88.86V81.8C275.39 49.69 283.6 39.46 303.33 39.46C323.06 39.46 330.4 50.12 330.4 81.8H330.41ZM310.25 75.03C310.25 58.04 308.67 53.14 303.05 53.14C297.43 53.14 295.56 58.04 295.56 75.03V95.34C295.56 112.91 297.29 117.37 302.76 117.37C308.66 117.37 310.25 112.91 310.25 95.34V75.03Z"
        fill="#212121"
      />
      <path
        d="M338.76 107.58V41.1899H358.63V105.49C358.63 113.27 360.36 116.72 364.46 116.72C367.56 116.72 370.58 115.35 372.74 109.59V41.1899H392.61V129.47H375.76L374.61 117.59H374.54C372.09 126.01 367.27 131.2 357.26 131.2C344.01 131.2 338.75 122.7 338.75 107.58H338.76Z"
        fill="#212121"
      />
      <path
        d="M406.58 129.47V25.6301H386.92V8.64014H446.11V25.6301H426.45V129.46H406.58V129.47Z"
        fill="#212121"
      />
      <path
        d="M440.64 107.58V41.1899H460.51V105.49C460.51 113.27 462.24 116.72 466.34 116.72C469.44 116.72 472.46 115.35 474.62 109.59V41.1899H494.49V129.47H477.64L476.49 117.59H476.42C473.97 126.01 469.15 131.2 459.14 131.2C445.89 131.2 440.63 122.7 440.63 107.58H440.64Z"
        fill="#212121"
      />
      <path
        d="M560.67 78.4902V90.3002C560.67 118.81 554.62 130.77 541.23 130.77C533.09 130.77 526.97 127.17 523.8 121.12H523.73L522.43 129.47H505.15V4.18018H524.3V29.5302C524.3 36.1502 524.44 42.7802 523.87 50.7002H524.09C527.4 44.0802 533.09 39.4702 542.02 39.4702C554.84 39.4702 560.67 47.8202 560.67 78.5002V78.4902ZM540.36 78.4902C540.36 58.0402 538.63 53.5802 533.09 53.5802C529.35 53.5802 525.74 56.8902 524.31 63.2302V111.98C526.04 115.36 529.06 116.8 532.23 116.8C538.21 116.8 540.37 110.46 540.37 91.3102V78.4902H540.36Z"
        fill="#212121"
      />
      <path
        d="M621 91.6598H588.09V96.4798C588.09 112.03 588.45 117.36 594.86 117.36C601.27 117.36 602.64 112.46 602.78 102.38L620.28 103.17C621.58 122.4 611.64 130.89 594.79 130.89C574.34 130.89 568.29 117.5 568.29 93.1598V77.7498C568.29 52.1198 575.06 39.5898 595.36 39.5898C615.66 39.5898 620.99 50.2498 620.99 76.8898V91.6498L621 91.6598ZM588.1 73.8798V80.5798H601.2V73.8798C601.2 57.6098 600.55 52.9998 594.58 52.9998C588.61 52.9998 588.1 57.7498 588.1 73.8798Z"
        fill="#212121"
      />
    </g>
    <defs>
      <clipPath id="youtubeWordmarkClip">
        <rect width="621" height="138.11" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
